// SCADA design tokens — single source of truth for the dispatcher dark theme.
// The cabinet codebase styles heavily with inline `style={{...}}`, so we expose
// tokens as plain TS constants (used inline) AND mirror the palette into
// tailwind.config.ts under `colors.scada.*` for utility classes.

export const scada = {
  bg: '#0E1116',        // app background (deep)
  panel: '#161B22',     // card background
  panel2: '#1C232C',    // nested / header background
  panelHover: '#222A34',
  border: 'rgba(255,255,255,0.08)',
  borderStrong: 'rgba(255,255,255,0.16)',

  text: '#E6EDF3',      // primary text
  textDim: '#9AA4B2',   // secondary
  textMuted: '#6B7480', // tertiary / labels

  accent: '#D12229',    // Helios brand red — selection / active

  // Operational state palette (status of an asset / device)
  state: {
    ok: '#22C55E',
    warning: '#F59E0B',
    alarm: '#EF4444',
    offline: '#6B7480',
    curtailed: '#38BDF8', // active power limit / СКО
    maintenance: '#A855F7',
    commissioning: '#EAB308',
  },

  // Data-quality palette (§12 quality field)
  quality: {
    good: '#22C55E',
    stale: '#F59E0B',
    buffered: '#38BDF8',
    read_error: '#EF4444',
    invalid: '#EF4444',
    manual: '#A855F7',
    simulated: '#6B7480',
  },
} as const;

export type OpState =
  | 'ok' | 'warning' | 'alarm' | 'offline'
  | 'curtailed' | 'maintenance' | 'commissioning';

export type Quality =
  | 'good' | 'stale' | 'buffered' | 'read_error'
  | 'invalid' | 'manual' | 'simulated';

export const STATE_LABEL: Record<OpState, string> = {
  ok: 'Норма',
  warning: 'Попередження',
  alarm: 'Аварія',
  offline: 'Немає звʼязку',
  curtailed: 'Обмеження',
  maintenance: 'Планові роботи',
  commissioning: 'Введення',
};

export const stateColor = (s: OpState): string => scada.state[s];
export const qualityColor = (q: Quality): string => scada.quality[q];
